import { Action, Dispatch } from 'redux';
import { IAppState } from './reducers';
import { IStorageSummary, getStorageMetricsByUser } from '../api/vault/storageSummary';

export interface IState {
    storage: IStorageSummary,
    isLoading: boolean,
    isOpen: boolean,
}

export enum ActionType {
  ClearStorageSummary ='StorageSummary.ClearStorageSummary',
  GetStorageSummary = 'StorageSummary.GetStorageSummary',
  IsStorageLoading = 'StorageSummary.IsStorageLoading',
  ToggleStorageSummary = 'StorageSummary.ToggleStorageSummary',
}

export interface IStorageSummaryPayload extends Action<ActionType> {
    payload?: IStorageSummary
}
const INITIAL_STATE: IState = {
  storage: null,
  isLoading: false,
  isOpen: false,
};

export default function reducer(state: IState = INITIAL_STATE, action: IStorageSummaryPayload): IState {
  switch (action.type) {
    case ActionType.GetStorageSummary:
      return {
        ...state,
        storage: action.payload,
      };
    case ActionType.ClearStorageSummary:
      return INITIAL_STATE;
    case ActionType.IsStorageLoading:
      return {
        ...state,
        isLoading: !state.isLoading,
      };
    case ActionType.ToggleStorageSummary:
      return {
        ...state,
        isOpen: true,
      };
    default:
      return state;
  }
}

export const getStorageSummary = () => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  const state = getState();

  const { storageSummary: { isLoading, isOpen, storage } } = { ...state };

  if (isOpen && !storage && !isLoading) {
    dispatch({
      type: ActionType.IsStorageLoading,
    });
    const response = await getStorageMetricsByUser();

    const newStorageSummary = response.data.data;

    if (newStorageSummary) {
      dispatch({
        payload: newStorageSummary,
        type: ActionType.GetStorageSummary,
      });
      dispatch({
        type: ActionType.IsStorageLoading,
      });
    }
  }
};

export const clearStorageSummary = () => ({
  type: ActionType.ClearStorageSummary,
});

export const toggleStorageSummary = () => ({
  type: ActionType.ToggleStorageSummary,
});
